import { render, staticRenderFns } from "./TcIcon.vue?vue&type=template&id=68c8dc90&"
import script from "./TcIcon.vue?vue&type=script&lang=js&"
export * from "./TcIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c8dc90')) {
      api.createRecord('68c8dc90', component.options)
    } else {
      api.reload('68c8dc90', component.options)
    }
    module.hot.accept("./TcIcon.vue?vue&type=template&id=68c8dc90&", function () {
      api.rerender('68c8dc90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcIcon.vue"
export default component.exports